import * as React from 'react';
import { Link } from 'react-static';
import * as classnames from 'classnames/bind';

import styles from './Tabs.scss';

const cx = classnames.bind(styles);

export interface TabsComponentProps {
  buttons: {
    text: string;
    href?: string;
    onClick?: () => void;
    isActive?: boolean;
  }[];
  theme?: 'light' | 'dark';
}

const Tabs: React.SFC<TabsComponentProps> = ({ buttons, theme = 'light' }) => {
  const className = cx({
    [theme]: true,
  });

  return (
    <div className={cx('wrapper', className)}>
      {buttons.map((button, index) => {
        return button.href ? (
          <Link
            key={index}
            to={button.href}
            scrollToTop={false}
            className={cx('button', className)}
            activeClassName={styles.isActive}
            dangerouslySetInnerHTML={{ __html: button.text }}
          />
        ) : (
          <button
            key={index}
            type="button"
            className={cx('button', { isActive: button.isActive }, className)}
            onClick={() => (button.onClick ? button.onClick() : undefined)}
            dangerouslySetInnerHTML={{ __html: button.text }}
          />
        );
      })}
    </div>
  );
};

export default Tabs;



// WEBPACK FOOTER //
// /www/client/src/components/Tabs/Tabs.tsx